export default __webpack_public_path__ + "static/media/hyo_seok_thomas_son.0aeb0db3.png";